import React from "react"
import { useVirtualizer } from "@tanstack/react-virtual"
import { GenericResource } from "models/generic"
import { twMerge } from "tailwind-merge"
import { useTable } from "../useTable"
import { VirtualInfiniteTableProps } from "./VirtualInfiniteTable"
import VirtualInfiniteTableTable from "./VirtualInfiniteTableTable"
import { isAldeia } from "hooks/useAldeia"
import useStuck from "hooks/useStuck"
import useFixScrollOffset from "hooks/useFixScrollOffset"

// var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
var isSafari = navigator.userAgent.toLowerCase().indexOf("safari/") > -1
export function VirtualInfiniteTableMobile<T extends GenericResource>(props: VirtualInfiniteTableProps<T>) {
  //we need a reference to the scrolling element for logic down below
  const tableContainerRef = React.useRef<HTMLDivElement>(null)
  const innerRef = React.useRef<HTMLDivElement>(null)
  useFixScrollOffset({
    containerRef: tableContainerRef as any,
    innerRef: innerRef as any,
    enabled: isAldeia && props.layout === "static",
    refresher: props.data?.length,
  })

  const { dummy } = useStuck({ enabled: isAldeia && props.layout === "static", scrollContainer: tableContainerRef.current! })

  const { rows, fetchMoreOnBottomReached, table } = useTable<T>({
    ...props,
    tableContainerRef: tableContainerRef as any,
    scrollToTop: () => {
      rowVirtualizer.scrollToIndex?.(0)
    },
  })

  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    estimateSize: () => (props.rowHeight ? props.rowHeight + 2 : 57), //estimate row height for accurate scrollbar dragging
    getScrollElement: () => tableContainerRef.current,

    //measure dynamic row height, except in firefox because it measures table border height incorrectly
    // measureElement:
    //   typeof window !== "undefined" && navigator.userAgent.indexOf("Firefox") === -1
    //     ? (element) => element?.getBoundingClientRect().height
    //     : undefined,
    overscan: props.overscan || 5,
  })

  return (
    <div
      className={twMerge(
        "max-w-full overflow-x-auto aldeia:pb-20",
        !props.local && "overflow-y-auto h-full",
        isAldeia && props?.isFetching && !props?.data?.length && "!overflow-y-hidden",
        props.className,
      )}
      onScroll={(e) => fetchMoreOnBottomReached(e.target as HTMLDivElement)}
      // onScroll={(e) => requestAnimationFrame(() => fetchMoreOnBottomReached(e.target as HTMLDivElement))}
      // onScroll={(e) => requestAnimationFrame(() => fetchMoreOnBottomReached(e.target as HTMLDivElement))}
      // onScroll={(e) => requestAnimationFrame(() => fetchMoreOnBottomReached(e.target as HTMLDivElement))}
      ref={tableContainerRef}
      style={{
        position: "relative", //needed for sticky header
        ...(isSafari && props.local
          ? { height: isAldeia ? "calc(var(--app-container-height) - var(--static-header-height))" : "calc(100vh - 60px)" }
          : {}),
        // ...(isSafari && !props.local ? { height: "calc(100vh - 60px)" } : {}),
      }}
    >
      <div ref={innerRef} className="w-full h-full">
        {dummy}
        {props.children}
        <VirtualInfiniteTableTable
          table={table}
          rowVirtualizer={rowVirtualizer}
          rows={rows}
          onClickRow={props.onClickRow}
          transparentHeader={props.transparentHeader}
          skeleton={(props?.isFetching && !props?.data?.length) || props.isFetchingNextPage}
          rowHeight={props.rowHeight}
          isStatic={props.layout === "static"}
        />
      </div>
    </div>
  )
}
